import { type ReviewActionT, REVIEW_ACTION_TYPE } from '../../review-action/constants';
import type { GenericAnnotationReviewDataT, QuestionsReviewDataT } from '../../types/types';
import { ANNOTATION_FILTER_TYPE, REVIEW_STATUS } from '../constants';
import type { AnnotationFilterT } from '../types/types';
export const addFilter = (currentFilters: AnnotationFilterT[], filter: AnnotationFilterT): AnnotationFilterT[] => {
  if (filter === ANNOTATION_FILTER_TYPE.ALL) {
    // @ts-expect-error todo(ts-migration) TS2322 Type 'string[]' is not assignable to type 'AnnotationFilterT[]'.
    return Object.keys(ANNOTATION_FILTER_TYPE).filter(currentFilter => currentFilter !== ANNOTATION_FILTER_TYPE.ALL);
  } else {
    return [...currentFilters, filter];
  }
};
export const removeFilter = (currentFilters: AnnotationFilterT[], filter: AnnotationFilterT): AnnotationFilterT[] => {
  if (filter === ANNOTATION_FILTER_TYPE.ALL) {
    return [];
  }
  return currentFilters.filter(currentFilter => currentFilter !== filter);
};
const getQuestionsStatus = (questionsReviewData?: QuestionsReviewDataT): AnnotationFilterT => {
  if (!questionsReviewData) {
    return REVIEW_STATUS.ACCEPTED;
  }
  const questionnaireIds = Object.keys(questionsReviewData);
  if (questionnaireIds.some(questionnaireId => {
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    return questionsReviewData[questionnaireId].status === REVIEW_STATUS.REJECTED;
  })) {
    return REVIEW_STATUS.REJECTED;
  }
  if (questionnaireIds.every(questionnaireId => {
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    return questionsReviewData[questionnaireId].status === REVIEW_STATUS.ACCEPTED;
  })) {
    return REVIEW_STATUS.ACCEPTED;
  }
  return REVIEW_STATUS.PENDING;
};
export const getAnnotationStatus = (reviewData: GenericAnnotationReviewDataT): AnnotationFilterT => {
  const questionStatus = getQuestionsStatus(reviewData.questions);
  if (reviewData.status === REVIEW_STATUS.REJECTED || questionStatus === REVIEW_STATUS.REJECTED) {
    return REVIEW_STATUS.REJECTED;
  }
  if (reviewData.status === REVIEW_STATUS.ACCEPTED && questionStatus === REVIEW_STATUS.ACCEPTED) {
    return REVIEW_STATUS.ACCEPTED;
  }
  return REVIEW_STATUS.PENDING;
};
export const getFilteredAnnotationIds = (currentFilters: AnnotationFilterT[], annotationReviewDataList: GenericAnnotationReviewDataT[]): string[] => {
  return annotationReviewDataList.filter(annotationReviewData => {
    const annotationStatus = getAnnotationStatus(annotationReviewData);
    return currentFilters.includes(annotationStatus);
  }).map(annotationReviewData => annotationReviewData.annotationId);
};
export const getNextAnnotationIdx = (filteredAnnotations: string[], currentIdx: number) => {
  if (filteredAnnotations.length - 1 === currentIdx) {
    return 0;
  } else {
    return currentIdx + 1;
  }
};
export const getPreviousAnnotationIdx = (filteredAnnotations: string[], currentIdx: number) => {
  if (currentIdx === 0) {
    return filteredAnnotations.length - 1;
  } else {
    return currentIdx - 1;
  }
};
export const getFilterTypeName = (filterType: AnnotationFilterT) => {
  return filterType.charAt(0).toUpperCase() + filterType.slice(1).toLowerCase();
};
export const getCardOverrides = (status?: ReviewActionT) => {
  return {
    Root: {
      style: ({
        $theme
      }) => {
        return {
          width: '100%',
          ...(status && status !== REVIEW_ACTION_TYPE.PENDING && {
            border: status === REVIEW_ACTION_TYPE.ACCEPT ? `${$theme.colors.borderPositive} solid` : `${$theme.colors.borderNegative} solid`
          })
        };
      }
    },
    Contents: {
      style: () => {
        return {
          margin: '5px 16px'
        };
      }
    },
    Body: {
      style: () => {
        return {
          marginBottom: '10px'
        };
      }
    }
  };
};